import React, { useRef, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import { ServiceCard } from "./ServiceCard";
import { useGetProductsEnAvantQuery } from "../../utils/api/product/product.api";

const AUTO_SCROLL_INTERVAL_MS = 4500;
const SERVICES_PAGE = 1;
const SERVICES_LIMIT = 10;

interface ServicesProps {
  title?: string;
  onReserve?: (service: any) => void;
}

const Services: React.FC<ServicesProps> = ({
  title = "NOS SERVICES",
  onReserve,
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const { data: produitsEnAvant, isLoading } = useGetProductsEnAvantQuery({
    page: SERVICES_PAGE,
    limit: SERVICES_LIMIT,
  });

  const items = produitsEnAvant?.results ?? [];

  useEffect(() => {
    if (isLoading || items.length <= 1) return;
    const el = scrollRef.current;
    if (!el) return;

    const step = () => {
      if (!el) return;
      const item = el.querySelector<HTMLElement>(".service-card");
      const itemWidth = item?.offsetWidth ?? el.clientWidth;
      const maxScroll = el.scrollWidth - el.clientWidth;
      if (maxScroll <= 0) return;
      const next = el.scrollLeft + itemWidth;
      if (next >= maxScroll - 2) {
        el.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        el.scrollBy({ left: itemWidth, behavior: "smooth" });
      }
    };

    const id = setInterval(step, AUTO_SCROLL_INTERVAL_MS);
    return () => clearInterval(id);
  }, [isLoading, items.length]);

  const handleReserve = (service: any) => {
    onReserve?.(service);
  };

  return (
    <section className="py-5 services-section">
      <div className="container">
        <div className="text-center mb-5">
          <h3 className=" text-uppercase  title-home-page-theme">{title}</h3>
        </div>

        <div ref={scrollRef} className="services-section__list">
          {isLoading
            ? Array(4)
                .fill(0)
                .map((_, i) => (
                  <div key={i} className="row align-items-center py-4 service-card justify-content-center">
                    <div className="col-12 col-md-5 mb-3 mb-md-0">
                      <Skeleton height={220} className="rounded-3 w-100" />
                    </div>
                    <div className="col-12 col-md-7 content-service">
                      <Skeleton width="60%" height={24} className="mb-2" />
                      <Skeleton count={2} height={12} className="mb-2" />
                      <Skeleton width={140} height={38} />
                    </div>
                  </div>
                ))
            : items.map((service) => (
                <ServiceCard
                  key={service.id}
                  item={service}
                  onReserve={handleReserve}
                />
              ))}
        </div>
      </div>
    </section>
  );
};

export default Services;